import React, { useEffect, useRef } from 'react';
import DOMPurify from 'dompurify';
import katex from 'katex';

// Renders sanitized Quill HTML and post-processes .ql-formula spans with KaTeX
export default function RichHtml({ html = '', className, sx, style }) {
  const ref = useRef(null);

  useEffect(() => {
    const root = ref.current;
    if (!root) return;
    // Render any .ql-formula elements with KaTeX
    const nodes = root.querySelectorAll('.ql-formula');
    nodes.forEach((el) => {
      const latex = el.getAttribute('data-value') || '';
      try {
        katex.render(latex, el, { throwOnError: false });
      } catch (e) {
        // ignore render errors
      }
    });
  }, [html]);

  const sanitized = DOMPurify.sanitize(html, {
    ADD_ATTR: ['data-value'],
  });

  return (
    <div
      ref={ref}
      className={className}
      style={style}
      // sx is for MUI Box; pass-through if wrapped externally
      dangerouslySetInnerHTML={{ __html: sanitized }}
    />
  );
}
